<template>
	<div v-if="isVisible" class="px-4 formField">
		<v-text-field
			:disabled="formField.Readonly"
			@keyup="uppercase"
			:class="getUppercaseClass"
			:rules="validationRules"
			:error-messages="validationError"
			:placeholder="dateTimeFormat"
			:label="formField.Label"
			hide-details="auto"
			v-model="dateTimeValue"
			prepend-icon="mdi-calendar"
			clearable
		>
			<template v-slot:append-outer v-if="canRetainValue">
				<v-icon v-if="!hasRetainedValue" @click="onPinClick"
					>mdi-pin-off-outline</v-icon
				>
				<v-icon
					v-else
					color="primary"
					class="rotate45"
					@click="onPinClick"
					>mdi-pin-outline</v-icon
				>
			</template>
			<template v-slot:prepend v-if="visibleBubble || visibleHelp">
				<div v-if="visibleBubble">
					<v-tooltip
						top
						nudge-top="20"
						:open-on-click="true"
						:open-on-focus="true"
						:open-on-hover="true"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								color="primary"
								v-bind="attrs"
								v-on="on"
								tabindex="-1"
								>mdi-information-outline</v-icon
							>
						</template>
						{{ bubbleText }}
					</v-tooltip>
				</div>
				<div v-if="visibleHelp">
					<v-tooltip
						top
						nudge-top="20"
						:open-on-click="true"
						:open-on-focus="true"
						:open-on-hover="true"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								color="primary"
								v-bind="attrs"
								v-on="on"
								tabindex="-1"
								>mdi-help-circle-outline</v-icon
							>
						</template>
						{{ helpText }}
					</v-tooltip>
				</div>
			</template>
		</v-text-field>
	</div>
</template>
<script>
import formFieldMixin from '../../../../mixins/inventoryForm/formFieldMixin';
import projectSettingsMixin from '../../../../mixins/projectSettingsMixin';
import fieldsValidationRules from '../../../../utils/fieldsValidationRules';
import moment from 'moment';
export default {
	name: 'DatetimeField',
	mixins: [formFieldMixin, projectSettingsMixin],
	computed: {
		validations() {
			return fieldsValidationRules;
		},
	},
	data() {
		return {
			dateTimeValue: null,
		};
	},
	watch: {
		dateTimeValue(newVal) {
			if (!newVal) {
				this.selectedValue = null;
				return;
			}

			let dateTimeValue = this.convertDateTimeFormLocaleToUtc(newVal);
			if (dateTimeValue != 'Invalid Date') {
				this.selectedValue = dateTimeValue;
			}
		},
	},
	mounted() {
		this.defaultRules.push((v) =>
			this.validations.validationDateNullable(
				v,
				this.getDateTimeFormatProjectSetting()
			)
		);
		this.defaultRules.push((v) => {
			if (this.formField.Required && !this.isBulkEdit) {
				if (!v) return false || 'The value is required';
				else return true;
			} else return true;
		});
		if (this.recordSelectedValue) {
			this.selectedValue = this.recordSelectedValue;
			this.dateTimeValue = this.convertDateTimeFromUtcToLocale(
				this.recordSelectedValue
			);
		}
	},
	methods: {
		convertDateTimeFromUtcToLocale(valueUtc) {
			let format = this.getDateTimeFormatProjectSetting();
			let momentutc = moment.utc(valueUtc);
			let dateStringLocale = momentutc.toLocaleString();
			let momentLocale = moment(dateStringLocale);
			let locale = momentLocale.format(format);
			return locale;
		},

		convertDateTimeFormLocaleToUtc(valueLocale) {
			let momentlocale = moment(valueLocale);
			let format = this.getDateTimeFormatProjectSetting();
			let utc = momentlocale.utc().format(format);
			return utc;
		},

		onRecordChanged() {
			if (
				this.recordSelectedValue &&
				this.selectedValue != this.recordSelectedValue
			) {
				this.selectedValue = this.recordSelectedValue;
				this.dateTimeValue = this.convertDateTimeFromUtcToLocale(
					this.recordSelectedValue
				);
				return;
			}

			if (
				this.selectedValue &&
				this.selectedValue != this.recordSelectedValue
			) {
				this.selectedValue = null;
				this.dateTimeValue = null;
			}
		},
		onHideFormField() {
			this.selectedValue = null;
		},
		onSelectedValueChanged(newVal) {
			this.skipNextRecordUpdate = true;
			this.$emit('selectedValueChanged', [
				{ key: this.recordKeys[0], value: newVal },
			]);
		},
		onSetInteraction(setValue) {
			this.onSelectedValueChanged(setValue);
		},
		onClearInteraction() {
			this.onSelectedValueChanged(null);
		},
	},
};
</script>
